export default "__VITE_ASSET__1jQ2J751__"